import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../../../components/layout/AppLayout';
import { dummyData } from './data';
import MonthlyProgress from './MonthlyProgress';
import StageProcess from './StageProcess';
import KeyDelays from './KeyDelays';
import { ArrowLeft } from 'lucide-react';

const SampleMonthlyReport = () => {
  const navigate = useNavigate();
  const monthlyProgressData = dummyData.monthlyProgress;
  const stageProcessData = dummyData.stageProcess;
  const keyDelaysData = dummyData.keyDelays;

  return (
    <Layout>
      <div className="bg-[#F8FAFC] min-h-screen">
        <div className="sticky top-0 z-40 bg-[#EEF3F7] backdrop-blur pt-6 px-6 pb-4">
          <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
            <div className="flex items-center gap-3">
              <button
                type="button"
                onClick={() => navigate('/builder/operations/monthly-reports')}
                className="flex items-center gap-2 px-3 py-2 text-[#526477] hover:bg-gray-100 rounded-md transition-colors text-sm font-medium"
              >
                <ArrowLeft size={20} />
                Back to Monthly Reports
              </button>
              <span className="h-5 w-px bg-[#526477] opacity-50" />
              <h1 className="text-lg font-bold text-[#111827]">Sample Monthly Report</h1>
              <span className="px-2 py-0.5 bg-[#1F4B55] text-white text-xs font-semibold rounded">Preview</span>
            </div>
            <div className="text-sm text-[#526477] font-medium">
              Project: {dummyData.projectName} · {dummyData.date}
            </div>
          </div>
        </div>
        <div className="px-6 pb-6 max-w-[1600px] mx-auto">
          <div className="flex flex-col gap-6">
            <div className="flex">
              <div
                className="bg-[#D4B95E] text-white px-10 py-3 font-medium text-base relative z-10 pr-16"
                style={{ clipPath: 'polygon(0 0, 100% 0, 85% 100%, 0% 100%)' }}
              >
                Progress Overview
              </div>
              <div
                className="bg-[#1E4C56] text-white px-10 py-3 font-medium text-base -ml-10 pl-16 relative z-0 pr-16"
                style={{ clipPath: 'polygon(0 0, 100% 0, 85% 100%, 0% 100%)' }}
              >
                Minor Delays
              </div>
            </div>
            <h1 className="text-2xl font-bold text-gray-900">Monthly Progress Report</h1>

            <MonthlyProgress data={monthlyProgressData} />

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
              <div>
                <StageProcess stages={stageProcessData} />
              </div>
              <div className="flex flex-col gap-6 h-full">
                <KeyDelays delays={keyDelaysData} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SampleMonthlyReport;
